<script>
  import axios from "axios"
  import { onMount } from "svelte"
  import SinglePublish, { updateSinglePublish } from "../Stores/singlePublishStore"
  import notify from "../../../../Script/notify"
  import DocSigning from "../../DocSigning/index.svelte"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import { loadJs } from "../../../../Script/loadLibrary"
  import ApplicationState from "../../../../Stores/applicationStates"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import Header from "../Components/Header.svelte"
  import LoadingScreen from "../Components/loadingScreen.svelte"
  import { getDocumentIdDetails } from "../script"
  import { validateFileType } from "../script"
  import { loadImage } from "../../BulkUpload/Script/bulkUpload"
  import { getFileFromBase64 } from "../../../../Script/getFileFromBase64"
  import { getRequest, postRequest } from "../../../../Script/apiMethods"
  import DocDetails from "../../../Signing/MultiSigner/Pages/CreateDocket/Stores/document"
  import { parsePdf } from "../../../Signing/MultiSigner/Pages/CreateDocket/Script/loadFile"
  import Modal from "../../../Signing/MultiSigner/Pages/CreateDocket/Components/modal.svelte"

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let apiCallBtnDisable = false

  /**
   * @type {String} - massage for loading screen
   */
  let msg

  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  /**
   * @type {Number} - this prob variable contains which sign model need to show
   */
  let signModelActive = 0

  /**
   * @type {Element} - publish button element
   */
  let publishBtn

  /** @type {HTMLElement}*/
  let canvas

  /**
   * @type {String} - signature background color
   */
  let SignBgClr

  /**
   * @type {Boolean} - signature background color
   */
  let signModel = false

  /**
   * @type {Boolean} - whether to show sign image or not
   */
  let signImg = false

  /**
   * @type {Boolean} - whether to show pdf loading screen or not
   */
  let loadingPDF = true

  /**
   * @type {Object} - store the pdf details
   */
  let _PDFDOC

  /**
   * @type {Number} - PDF total page number
   */
  let totalPages

  /**
   * @type {Number} - PDF current page number
   */
  let currentpage = 1

  /**
   * @type {Number} - while changing pages number simultaneously that pages number stored as pending page number
   */
  let pageNumPending = null

  /**
   * @type {Object} - uploaded pdf file details
   */
  let fileDetails

  /**
   * @type {File} - if pdf uploaded that pdf file data placed
   */
  let pdfFile = null

  /**
   * @type {Boolean} - whether to show blue clr postion overlay or not
   */
  let showPositionOverlay = false

  /**
   *@type {HTMLElement} - signature image image tag
   */
  let signImageElem

  /**
   * @type {HTMLElement} - blue layer of the position overlay
   */
  let positionOverlay

  /**
   * @type {HTMLElement} - button element for Position Overlay activation
   */
  let activatePositionOverlayBtn

  /**
   * @type {HTMLElement} - toggle button for horizontal lock
   */
  let toggle

  /**
   *@type {HTMLElement} - PDF signing overall element
   */
  let signingForm

  /**
   * @type {String} - to store the sign temp position on PDF
   */
  let tempPosition = ""

  /**
   * @type {String} - to store the sign position PDF
   */
  let pdfPosition = tempPosition

  /**
   * @type {Boolean} - whether to sign want to horisontaly lock or not
   */
  let horizontallyLock = false

  /**
   *@type {HTMLElement} - uploaded image
   */
  let uploadedImage

  let mobileViewPdfPreview = false

  let isPdfDigitallySigned = false
  let pdfDigitallySignedModal = false

  /**
   * @type {fileNotify}
   */
  let fileNotify = {
    close() {},
  }

  /**
   * @type {invalidFileNotify}
   */
  let invalidFileNotify = {
    close() {},
  }

  /**
   * @type {signModelCloseInfo}
   */
  let signModelCloseInfo = {
    close() {},
  }

  let disableWhileLoading = false

  /**
   * fetch new document id details or start a fresh process for file uploading or draw signed pdf based on contition
   */
  onMount(async () => {
    try {
      console.log("onMount")

      //set new documnet id details to the local storage
      // if ($SinglePublish.documentId != query.documentId) await getDocumentIdDetails()
      // else {
      // Enabling loading screen
      apiCallBtnDisable = true
      //make signature modal false initially
      signModel = false
      // Make ipfs uri of the file in the stores as empty initially.
      $SinglePublish.uri = ""

      if ($SinglePublish.signedPDFName) {
        // Await the function to draw the signed PDF
        await drawSignedPdf()
      }
      // }
      // }
    } catch (error) {
      const info = "PAGE: Single Publish (Upload Document)\nEVENT: onMount"
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
      disableWhileLoading = false
    }
  })

  /**
   * UploadFile is an asynchronous function to handle file uploads.
   * It validates the file type and processes it accordingly.
   *
   * @param {Event} e - The event object from the file input or drag-and-drop.
   */
  const UploadFile = async (e) => {
    // Close any existing invalid file notification
    invalidFileNotify.close()

    const info = "PAGE: Single Publish (Upload Document)\nEVENT: During validation of uploaded document"

    // Reset the current page to 1
    currentpage = 1

    // Get the uploaded file data, depending on whether it's from drag-and-drop or file input
    let fileData = e.dataTransfer ? e.dataTransfer.files : e.target.files

    const MAX_FILE_SIZE = 2 * 1024 * 1024

    if (MAX_FILE_SIZE < fileData[0].size) {
      // Clear the file input value
      e.dataTransfer ? (e.dataTransfer.value = null) : (e.target.value = null)

      // Show an invalid file format notification
      invalidFileNotify = notify.danger("Maximum size Exceeded", info)
      return
    }

    // Check if the file type is neither PDF nor image
    if (fileData[0].type !== "application/pdf" && fileData[0].type.split("/")[0] !== "image") {
      // Clear the file input value
      e.dataTransfer ? (e.dataTransfer.value = null) : (e.target.value = null)

      // Show an invalid file format notification
      invalidFileNotify = notify.danger("Invalid file format. Upload PDF or IMAGE file", info)
      return
    }

    // Check if there is file data
    if (fileData) {
      // Store the first file's details
      fileDetails = fileData[0]

      try {
        // Validate the file type and store the validated file
        pdfFile = await validateFileType(fileDetails)

        // Check if the file type is PDF
        if (pdfFile.type == "application/pdf") {
          // Create an object URL for the PDF file and store it in $SinglePublish stores
          $SinglePublish.uri = URL.createObjectURL(pdfFile)
          $SinglePublish.fileType = "pdf"

          disableWhileLoading = true
          // Display the PDF using the showPDF function
          await showPDF($SinglePublish.uri)
        } else {
          // For image files
          $SinglePublish.uri = URL.createObjectURL(pdfFile)

          // Load the image and store it
          uploadedImage = await loadImage($SinglePublish.uri)
          $SinglePublish.fileType = "image"
          loadingPDF = false
        }

        // Store the processed PDF file in $SinglePublish
        $SinglePublish.pdfFile = pdfFile
        isPdfDigitallySigned = await parsePdf(pdfFile)

        // Set the sign model to inactive
        signModelActive = 0
      } catch (error) {
        // Handle any errors that occur during file processing
        if (error.message == "No password given") {
          // Show a notification if the file is encrypted
          invalidFileNotify = notify.danger("Encrypted file not allowed", info)
          $SinglePublish.uri = ""
          $SinglePublish.pdfFile = ""
        } else {
          // Show a notification for other errors
          invalidFileNotify = notify.danger(error, info)
        }
      } finally {
        disableWhileLoading = false
      }
    }
  }

  /**
   * Converts an uploaded image to a PDF format using jsPDF.
   *
   * @param {HTMLImageElement} uploadedImage - The image element to convert to PDF.
   * @returns {Promise<string>} - A promise that resolves to the PDF data URI.
   */
  const imageToPdf = (uploadedImage) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Load the jsPDF library dynamically
        await loadJs("jsPDF", "assets/lib/jspdf.min.js")

        // Create a new jsPDF document with specified options
        const doc = new jsPDF({
          orientation: "portrait", // Page orientation: 'portrait' or 'landscape'
          unit: "px", // Measurement unit: 'mm', 'pt', 'in', 'px'
          format: [uploadedImage.naturalWidth, uploadedImage.naturalHeight], // Page size in width and height based on the image dimensions
        })

        // Add the image to the PDF document at the specified coordinates (0, 0)
        doc.addImage(uploadedImage, 0, 0)

        // Output the PDF document as a data URI string
        let uri = doc.output("datauristring")

        // Resolve the promise with the data URI string
        resolve(uri)
      } catch (error) {
        // Reject the promise with an error message if there is an issue
        reject("Invalid file format. Upload PDF file")
      }
    })
  }

  /**
   * Loads and displays a PDF from the given URL using pdf.js.
   *
   * @param {string} url - The URL of the PDF to display.
   * @returns {Promise<void>} - A promise that resolves when the PDF is successfully loaded and displayed.
   */
  const showPDF = async (url) => {
    // Set the loading flag to true to indicate that the PDF is loading
    loadingPDF = true

    // Hide the signature image if it's visible
    if (signImg) signImg = false

    // Load the pdf.js library if it's not already loaded
    await loadJs("pdfjsLib", "assets/lib/pdf.js")

    // Load the pdf.js worker if it's not already loaded
    await loadJs("pdfjsWorker", "assets/lib/pdf.worker.js")

    // Specify the workerSrc property for pdf.js
    pdfjsLib.GlobalWorkerOptions.workerSrc = "assets/lib/pdf.worker.js"

    // Start downloading the PDF asynchronously
    let loadingTask = pdfjsLib.getDocument(url)

    // Await the completion of the PDF loading task
    loadingTask = loadingTask.promise
    _PDFDOC = await loadingTask

    // Get the total number of pages in the PDF document
    totalPages = _PDFDOC.numPages

    // Scroll the publish button into view if it exists
    if (publishBtn) publishBtn.scrollIntoView()

    // Display the current page of the PDF
    showPage(currentpage)
  }

  /**
   * Renders a specific page of the loaded PDF document onto a canvas.
   *
   * @param {number} pageno - The page number to display.
   * @returns {Promise<void>} - A promise that resolves when the page is successfully rendered.
   */
  const showPage = async (pageno) => {
    try {
      // Set the loading flag to true to indicate that a PDF page is being loaded
      loadingPDF = true

      // Get the specified page from the PDF document
      let page = await _PDFDOC.getPage(pageno)

      // Get the viewport for the page at a scale of 1
      let viewport = page.getViewport({ scale: 1 })

      // Prepare the canvas using the PDF page dimensions
      let context = canvas.getContext("2d")
      canvas.height = viewport.height
      canvas.width = viewport.width

      // Create the render context with canvas context and viewport
      let renderContext = {
        canvasContext: context,
        viewport: viewport,
      }

      // Render the PDF page into the canvas context
      await page.render(renderContext).promise

      // Set the loading flag to false to indicate that the PDF page has finished loading
      loadingPDF = false

      // Check if a new page rendering is pending
      if (pageNumPending !== null) {
        // Render the pending page and reset the pending page number
        showPage(pageNumPending)
        pageNumPending = null
      }
    } catch (error) {
      // Set the loading flag to true in case of an error (could be false as well to stop loading indicator)
      loadingPDF = true
      // Log the error (commented out)
      // console.error(error);
    } finally {
      // Add any finalization code here if needed
    }
  }

  /**
   * Queues a page to be rendered if a PDF page is currently being loaded.
   * If no page is being loaded, it immediately renders the specified page.
   *
   * @param {number} pageno - The page number to render.
   */
  function queueRenderPage(pageno) {
    // Check if a PDF page is currently being loaded
    if (loadingPDF) {
      // Set the pending page number to the specified page number
      pageNumPending = pageno
    } else {
      // Render the specified page immediately
      showPage(pageno)
    }
  }

  /**
   * Changes the current page of the PDF based on user input and renders the new page.
   *
   * @param {Event} e - The event object from the input field.
   */
  const changePdfPageNo = (e) => {
    // Check if the entered page number is less than the total number of pages and not zero
    if (e.target.value <= totalPages && e.target.value != 0) {
      // Update the current page number with the entered value
      currentpage = Number(e.target.value)
      // Queue the rendering of the new page
      queueRenderPage(currentpage)
    } else {
      // If the entered page number exceeds the total number of pages
      if (e.target.value > totalPages) {
        let prevPage = currentpage

        // Set the current page number to the last page
        currentpage = totalPages

        // Queue the rendering of the last page
        if (prevPage != currentpage) queueRenderPage(totalPages)
      } else if (e.target.value < 1) {
        // If the entered page number is less than 1
        // Clear the current page number input
        currentpage = ""
        // Show the first page of the PDF
        showPage(1)
      }
    }
  }

  /**
   * Changes the current page of the PDF based on scroll input and renders the new page.
   *
   * @param {WheelEvent} e - The wheel event object.
   */
  const changePdfPageNoWhileScroll = (e) => {
    // If the scroll direction is up and the current page is less than the total pages
    if (e.deltaY < 0 && currentpage > 1) {
      // Increment the current page number
      currentpage--
      // Queue the rendering of the new page
      queueRenderPage(currentpage)
    }
    // If the scroll direction is down and the current page is greater than 1
    else if (e.deltaY > 0 && currentpage < totalPages) {
      // Decrement the current page number
      currentpage++
      // Queue the rendering of the new page
      queueRenderPage(currentpage)
    }
    // The commented out else block can be used to handle other scroll events if needed
    // else {
    //   e.preventDefault()
    // }
  }

  /**
   * Opens the signature model for signing on the PDF.
   * Sets necessary flags and prepares the environment for signing.
   *
   * @returns {Promise<void>} - A promise that resolves when the signature model is opened.
   */
  const openSignModel = async () => {
    // Set the signImg flag to true to indicate the signature model is open
    signImg = true

    // Close any existing file notifications
    fileNotify.close()

    // If $SinglePublish.uri is not set, display an error notification
    if (!$SinglePublish.uri) {
      fileNotify = notify.danger("<strong>Upload File</strong>")
    } else {
      // If $SinglePublish.uri is set, proceed to open the signature model
      signModel = true // Set the signModel flag to true
      loadingPDF = true // Set the loadingPDF flag to true to indicate loading
      showPositionOverlay = false // Hide the position overlay

      // Show the current page of the PDF
      await showPage(currentpage)

      // Set the temporary signature position
      // a rectangle with coordinates (98, 376) as the top-left corner and (496, 448) as the bottom-right corner.
      tempPosition = "98, 376, 496, 448"

      // Reset the sign position (assuming it resets the signature position)
      resetSignPosition()
    }
  }

  /**
   * Resets the position of the signature image element to center it within its parent element.
   */
  const resetSignPosition = () => {
    // Calculate the top position to center the signature image vertically
    signImageElem.style.top = (signImageElem.parentElement.clientHeight - signImageElem.clientHeight) / 2 + "px"

    // Calculate the left position to center the signature image horizontally
    signImageElem.style.left = (signImageElem.parentElement.clientWidth - signImageElem.clientWidth) / 2 + "px"
  }

  /**
   * Adjusts the position of the signature image element based on mouse movements over the position overlay.
   *
   * @param {MouseEvent} e - The mouse event object containing information about the mouse position.
   */
  const positionOverlayMouseCapture = (e) => {
    // Calculate the ratio of the actual document size to the displayed overlay size
    let ratio = 842 / positionOverlay.clientHeight

    // Initialize variables for x and y positions
    let x = 0
    let y = 0

    // Determine if the mouse pointer is closer to the bottom or top of the position overlay
    let bottom = positionOverlay.clientHeight > e.offsetY + signImageElem.clientHeight / 2
    let top = e.offsetY - signImageElem.clientHeight / 2 > 0

    // Determine if the mouse pointer is closer to the right or left of the position overlay
    let right = positionOverlay.clientWidth > e.offsetX + signImageElem.clientWidth / 2
    let left = e.offsetX - signImageElem.clientWidth / 2 > 0

    // Calculate the y position of the signature image based on mouse pointer location
    if (!bottom && top) {
      // If closer to the top and not at the bottom, position near the bottom of the overlay
      y = positionOverlay.clientHeight - signImageElem.clientHeight
    }
    if (bottom && !top) {
      // If closer to the bottom and not at the top, position at the top of the overlay
      y = 0
    }
    if (bottom && top) {
      // If both conditions meet, position at the mouse pointer's vertical midpoint
      y = e.offsetY - signImageElem.clientHeight / 2
    }

    // Calculate the x position of the signature image based on mouse pointer location
    if (horizontallyLock) {
      // If horizontal lock is enabled, center the signature horizontally within its parent
      x = (signImageElem.parentElement.clientWidth - signImageElem.clientWidth) / 2
    } else {
      // Otherwise, position based on proximity to overlay edges
      if (!left && right) {
        // If closer to the right and not to the left, position at the left edge of the overlay
        x = 0
      }
      if (left && !right) {
        // If closer to the left and not to the right, position at the right edge of the overlay
        x = positionOverlay.clientWidth - signImageElem.clientWidth
      }
      if (left && right) {
        // If both conditions meet, position at the mouse pointer's horizontal midpoint
        x = e.offsetX - signImageElem.clientWidth / 2
      }
    }

    // Set the left and top styles of the signature image element to position it on the overlay
    signImageElem.style.left = Math.floor(x) + "px"
    signImageElem.style.top = Math.floor(y) + "px"

    // Calculate the scaled coordinates for the signature position and update `tempPosition`
    let x1 = Math.floor(x * ratio)
    let y1 = Math.floor((positionOverlay.clientHeight - y - signImageElem.clientHeight) * ratio)
    let x2 = Math.floor(x * ratio + 398) // Assuming 398 is a fixed width related to the signature position
    let y2 = Math.floor((positionOverlay.clientHeight - y) * ratio)
    tempPosition = `${x1}, ${y1}, ${x2}, ${y2}`
  }

  /**
   * Activates the position overlay for positioning the signature.
   * Sets various flags and disables the activation button temporarily.
   */
  const activatePositionOverlay = async () => {
    // Scroll canvas into view if needed
    // canvas.scrollIntoView();

    // Set flag indicating mobile view PDF preview is active
    mobileViewPdfPreview = true

    // Set flag indicating signature image is active
    signImg = true

    // Set flag indicating position overlay should be shown
    showPositionOverlay = true

    // Set horizontal lock based on toggle value
    horizontallyLock = toggle

    // Disable the activatePositionOverlayBtn temporarily to prevent multiple activations
    activatePositionOverlayBtn.disabled = true

    // Optionally, delay execution of resetSignPosition for 10 milliseconds
    // setTimeout(() => resetSignPosition(), 10);
  }

  /**
   * Deactivates the position overlay for signature positioning.
   * Enables the activation button and updates the PDF position with the temporary position.
   */
  const deactivatePositionOverlay = () => {
    // Enable the activatePositionOverlayBtn to allow reactivation
    activatePositionOverlayBtn.disabled = false

    // Hide the position overlay
    showPositionOverlay = false

    // Update the PDF position with the temporary position
    pdfPosition = tempPosition
  }

  /**
   * Downloads and displays the signed PDF file.
   * Fetches the signed PDF file from the server and updates the UI to display it.
   */
  const drawSignedPdf = async () => {
    try {
      // Check if the browser is online; throw an error if offline
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      // Fetch the signed PDF file from the server
      // const response = await axios.get(`/api/pdfsigner/v2/download/${$SinglePublish.signedPDFName}`, { responseType: "blob" })
      const response = await axios.get(`/api/pdf-signing/v2/download/${$SinglePublish.signedPDFName}`, { responseType: "blob" })

      // Create a File object from the response blob
      const myFile = new File([response.data], "signedPdf.pdf", {
        type: "application/pdf",
      })

      // Update $SinglePublish.uri with the object URL of the File
      $SinglePublish.uri = URL.createObjectURL(myFile)

      // Update $SinglePublish.pdfFile with the File object
      $SinglePublish.pdfFile = myFile

      // Show the signed PDF in the UI by calling the showPDF function
      await showPDF($SinglePublish.uri)

      // Re-enable the API call button after successfully displaying the PDF
      apiCallBtnDisable = false
    } catch (error) {
      // Handle errors, such as network errors or API failures
      // console.error(error);
    }
  }

  /**
   * Closes the sign model and performs necessary cleanup actions.
   * Updates UI states and ensures proper handling after closing the sign model.
   */
  const clsSignModel = () => {
    // Set signModel flag to false to close the sign model
    signModel = false

    // Deactivate the position overlay used for signature positioning
    deactivatePositionOverlay()

    // Show the PDF in the UI again after closing the sign model
    showPDF($SinglePublish.uri)
  }

  /**
   * @description function for submit file are genarate file hash for uploaded file
   */
  const NextPage = async () => {
    //Indicate message in loading screen
    msg = "Document submitting"
    // close the existing signModelCloseInfo notifiction
    signModelCloseInfo.close()
    // close the existing fileNotify notifiction
    fileNotify.close()
    // Update the signature position into the File.
    pdfPosition = tempPosition

    const info = "PAGE: Single Publish (Upload Document)\nEVENT: During processing of uploaded document"

    // if no uri value in the stores then throw error to upload file.
    if (!$SinglePublish.uri) {
      fileNotify = notify.danger("Kindly upload file to continue", info)
    } else {
      try {
        // Enabling the loading screen to indicate that api call is to be loading.
        apiCallBtnDisable = true
        // Api call to create new file-hash
        const { data } = await axios.patch(
          // `/api/swagger/v2/docs/add-file`,//post
          `/api/swagger/v2/documents/${$SinglePublish.documentId}/add-file`,
          {
            //document id fom stores
            documentID: $SinglePublish.documentId,
            // File uri from stores
            file: $SinglePublish.pdfFile,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "x-access-token": $ApplicationState.token,
            },
          }
        )

        // Check if the response has an error and is not successful
        if (data.error && !data.success) {
          throw data.errorCode // Throw the error code
        }
        // update the single publish store values from data got from the api call
        $SinglePublish.uri = `/ipfs/${data.filename}`
        $SinglePublish.fileHash = data.fileHash
        // push(`/publish/single/metadata?documentId=${$SinglePublish.documentId}`)
        push(`/publish/single/choose_template?documentId=${$SinglePublish.documentId}`)
        // updateSinglePublish($SinglePublish)
      } catch (error) {
        if (error == "P2BCODE::DOCUMENT_DOES_NOT_EXIST") {
          localStorage.removeItem("P2BSinglePublish")
          $SinglePublish = {}
          push("/publish/single")
        }

        fileNotify = notify.danger(error, info)

        $SinglePublish.signedPDFName = ""
        $SinglePublish.downloadlink = ""
        $SinglePublish.uri = ""
        $SinglePublish.pdfFile = {}
      } finally {
        apiCallBtnDisable = false
        updateSinglePublish($SinglePublish)
      }
    }
  }

  const navigateToDocket = () => {
    $DocDetails.id = query.documentId
    $DocDetails.file = $SinglePublish.pdfFile
    $DocDetails.url = $SinglePublish.QRCode
    $DocDetails.isPdfDigitallySigned = isPdfDigitallySigned

    // console.log({ $SinglePublish })

    // console.log({ $DocDetails }, "single publish")

    push("/signing/multiSigner/docket")
  }
</script>

<svelte:window
  on:load={() => {
    // push(`/publish/single?documentId=${query.documentId}&docketId=${query.docketId}`)
  }}
/>
<svelte:head>
  <title>Single Document Publish</title>
</svelte:head>

{#if pdfDigitallySignedModal}
  <Modal
    title="Confirmation"
    btnName="Confirm"
    on:click={() => {
      pdfDigitallySignedModal = false
      isPdfDigitallySigned = false
      $SinglePublish.uri = null
    }}
    on:confirm={async () => {
      pdfDigitallySignedModal = false
      navigateToDocket()
      // await showAddSignerSection()
    }}
  >
    <div class="w-3/4 break-words p-3 text-center text-gray-d00 dark:text-gray-200 mobile:p-6">
      The document you uploaded is digitally signed. Because of this, <strong class="text-blue-500">users cannot add an e-signature</strong>
      , as doing so would invalidate the existing digital signatures. Additionally, users will not be able to select any preferred signing method.
    </div>
  </Modal>
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div class="relative mx-auto h-auto w-full max-w-[920px] pb-40 pt-6">
      <Header bind:apiCallBtnDisable bind:msg />
      {#if !signModel}
        <div class="relative flex min-h-[470px] flex-col justify-between gap-6 rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
          <div class="flex flex-col justify-start gap-3">
            <!-- <p class="w-full select-none break-words text-justify text-sm text-gray-200 mobile:text-base sm:w-3/4 md:text-base">
              Clicking the confirm button locks in selected details. Start a new process to make changes. Complete all steps before confirming.
            </p> -->

            {#if !$SinglePublish.uri}
              <div class="relative mx-auto mt-9 flex w-full flex-col items-center justify-center gap-3 rounded-md border border-dashed border-gray-200 px-12 py-12 hover:border-gray-200/50 hover:bg-[#f7f7f7] hover:dark:bg-bodyblack sm:w-1/2">
                <input on:change={UploadFile} type="file" accept=".pdf,.png,.jpeg,.jpg" class="absolute inset-0 cursor-pointer opacity-0" />
                <div class="text-xl text-blue-500 lg:text-3xl">
                  <i class="fa-solid fa-cloud-arrow-up" />
                </div>
                <span class="md:txet-base select-none text-center text-sm font-medium text-gray-200">Select a file by dragging and dropping it, or Click here to upload</span>
                <span class="select-none text-center text-xs font-normal text-gray-100 md:text-sm">Maximum Size 2MB</span>
                <span class="select-none text-center text-xs font-normal text-blue-500 md:text-sm">Supported formats: PDF and IMAGE only.</span>
              </div>
            {:else}
              <!-- aspect-[1/1.4142] -->
              <div class="mx-auto flex w-full flex-col overflow-hidden rounded-md mobile:w-1/2 {loadingPDF ? 'animate-pulse bg-gray-100/20' : ''} flex-col items-center justify-center gap-3">
                <div class="relative flex w-full items-center justify-center">
                  <!-- {$SinglePublish.fileType == 'pdf' ? 'aspect-[1/1.4142]' : ''} -->
                  <button
                    on:click={() => {
                      loadingPDF = true
                      $SinglePublish.uri = ""
                      $SinglePublish.signedPDFName = ""
                      $SinglePublish.downloadlink = ""
                      pdfFile = null
                      updateSinglePublish($SinglePublish)
                    }}
                    class="{showPositionOverlay || loadingPDF ? 'hidden' : 'block'} absolute right-6 top-6 flex h-6 w-6 items-center justify-center rounded-full bg-gray-500 text-white hover:bg-red-600 active:bg-red-400"
                  >
                    <i class="fa-solid fa-xmark" />
                  </button>
                  <!-- {#if pdfFile} -->
                  {#if $SinglePublish.fileType == "pdf"}
                    <canvas on:wheel|preventDefault|stopPropagation={(e) => changePdfPageNoWhileScroll(e)} bind:this={canvas} class="h-full w-full rounded-md {loadingPDF ? '' : 'border border-gray-300'}" />
                  {:else if uploadedImage}
                    <!-- svelte-ignore a11y-img-redundant-alt -->
                    <!-- <img src={$SinglePublish.uri} alt="publish image" class="h-[{uploadedImage.naturalHeight}px] w-[{uploadedImage.naturalWidth}px]" /> -->
                    <img src={$SinglePublish.uri} alt="publish image" class="aspect-auto w-full" />
                  {/if}
                  <!-- {/if} -->
                </div>
              </div>
              <!-- {#if pdfFile} -->
              {#if pdfFile && (pdfFile.type == "application/pdf" || pdfFile.type == "application/octet-stream")}
                <div class="{!loadingPDF ? 'opacity-100' : ' opacity-0'}  flex w-full items-center justify-center gap-3 md:mt-3">
                  <!-- Previous Page Button -->
                  <button
                    on:click={() => {
                      currentpage--
                      queueRenderPage(currentpage)
                    }}
                    type="button"
                    disabled={currentpage == 1}
                    class="flex h-6 w-6 items-center justify-center rounded-full border-2 border-gray-800 text-xs text-gray-800 hover:border-black hover:text-black active:border-white active:bg-blue-500 active:text-white disabled:cursor-not-allowed dark:hover:border-white dark:hover:text-white md:h-8 md:w-8 md:text-base"
                  >
                    <i class="fa-solid fa-chevron-left" />
                  </button>

                  <!-- Page Number Input Box -->
                  <div class="flex h-8 w-auto items-center justify-between px-2">
                    <input
                      min="1"
                      max={totalPages}
                      bind:value={currentpage}
                      type="number"
                      disabled={totalPages == 1}
                      class="w-auto rounded-md border border-none bg-transparent text-left font-mono font-bold text-black focus:outline-none dark:text-white"
                      on:input|stopPropagation={changePdfPageNo}
                      on:wheel|preventDefault|stopPropagation={changePdfPageNoWhileScroll}
                      on:paste|preventDefault
                      on:blur={() => {
                        if (currentpage == "") currentpage = 1
                      }}
                    />

                    <p class="select-none text-center font-mono font-bold text-gray-800">
                      /&nbsp;{totalPages}
                    </p>
                  </div>

                  <!-- Next Page Button -->
                  <button
                    on:click={() => {
                      currentpage++
                      queueRenderPage(currentpage)
                    }}
                    type="button"
                    disabled={currentpage == totalPages}
                    class="flex h-6 w-6 items-center justify-center rounded-full border-2 border-gray-800 text-xs text-gray-800 hover:border-black hover:text-black active:border-white active:bg-blue-500 active:text-white disabled:cursor-not-allowed dark:hover:border-white dark:hover:text-white md:h-8 md:w-8 md:text-base"
                  >
                    <i class="fa-solid fa-chevron-right" />
                  </button>
                </div>
              {/if}
            {/if}
            <!-- {/if} -->
          </div>

          <div class="flex w-full flex-col justify-between gap-3 mobile:flex-row sm:justify-end">
            {#if $SinglePublish.downloadlink}
              <a href={$SinglePublish.downloadlink} target="_blank" class="flex h-9 w-auto min-w-[36px] cursor-pointer items-center justify-center gap-2 rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-center text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed lg:px-4">
                <i class="fa-solid fa-down-to-bracket" />
                Download PDF
              </a>
            {:else if pdfFile && pdfFile.type == "application/pdf" && $ApplicationState.pdfEnabled}
              <button
                disabled={disableWhileLoading}
                on:click={() => {
                  if (isPdfDigitallySigned) pdfDigitallySignedModal = true
                  else navigateToDocket()
                }}
                type="button"
                class="flex h-9 w-auto min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-300 disabled:hover:bg-green-400 disabled:active:bg-green-200 lg:px-4"
              >
                <i class="fa-solid fa-signature" />
                <span class="select-none md:block">&nbsp;&nbsp;PDF Digital sign&nbsp;</span>
              </button>
            {/if}
            <button disabled={disableWhileLoading} bind:this={publishBtn} on:click={NextPage} type="button" class="flex h-9 w-auto min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 disabled:hover:bg-blue-400 disabled:active:bg-blue-200 lg:px-4">
              <i class="fa-solid fa-check" />
              <span class="select-none md:block">&nbsp;&nbsp;Confirm and Upload</span>
            </button>
          </div>
          {#if apiCallBtnDisable}
            <LoadingScreen {msg} />
          {/if}
        </div>
      {:else}
        <div class="fixed inset-0 z-20 flex h-full flex-col overflow-auto sm:flex-row">
          <div class="{mobileViewPdfPreview ? 'fixed z-30 mobile:relative' : 'fixed mobile:relative'} flex h-screen w-full flex-col items-center justify-center bg-[#000000cc] px-3 backdrop-blur-lg dark:bg-lightgray mobile:h-full lg:w-8/12 xls:w-9/12">
            <div on:wheel|preventDefault|stopPropagation={(e) => changePdfPageNoWhileScroll(e)} class="flex h-4/5 w-full flex-col items-center justify-center gap-3">
              <div class="relative flex aspect-[1/1.4142] items-center justify-center {loadingPDF ? 'animate-pulse bg-gray-100/10' : ''}  overflow-hidden rounded-md">
                <canvas bind:this={canvas} class="block h-full w-full rounded-md border-2 border-gray-300" />
                {#if showPositionOverlay}
                  <button class="absolute h-full w-full cursor-all-scroll bg-blue-500/50" bind:this={positionOverlay} on:mousemove={positionOverlayMouseCapture} on:click={deactivatePositionOverlay} />
                {/if}
                {#if signImg}
                  <div class="pointer-events-none absolute h-full w-full">
                    <img alt="signImg" src="assets/img/signSample.png" class="pointer-events-none absolute z-10 w-[67%] cursor-all-scroll select-none" bind:this={signImageElem} style="background: {SignBgClr};" />
                  </div>
                {/if}
              </div>
            </div>
            <div class="{!loadingPDF ? 'opacity-100' : ' opacity-0'} mt-3 flex w-full items-center justify-center gap-3">
              <!-- Previous Page Button -->
              <button
                on:click={() => {
                  currentpage--
                  queueRenderPage(currentpage)
                }}
                type="button"
                disabled={currentpage == 1}
                class="flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-800 text-gray-800 hover:border-white hover:text-white active:bg-blue-500 disabled:cursor-not-allowed"
              >
                <i class="fa-solid fa-chevron-left" />
              </button>

              <!-- Page Number Input Box -->
              <div class="group flex h-8 w-auto items-center justify-between px-2">
                <input
                  min="1"
                  max={totalPages}
                  bind:value={currentpage}
                  type="number"
                  disabled={totalPages == 1}
                  class="w-auto rounded-md border border-none bg-transparent text-left font-mono font-bold text-white focus:outline-none"
                  on:input|stopPropagation={changePdfPageNo}
                  on:wheel|preventDefault|stopPropagation={changePdfPageNoWhileScroll}
                  on:paste|preventDefault
                  on:blur={() => {
                    if (currentpage == "") currentpage = 1
                  }}
                />

                <p class="select-none text-center font-mono font-bold text-gray-200">
                  /&nbsp;{totalPages}
                </p>
              </div>

              <!-- Next Page Button -->
              <button
                on:click={() => {
                  currentpage++
                  queueRenderPage(currentpage)
                }}
                type="button"
                disabled={currentpage == totalPages}
                class="flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-800 text-gray-800 hover:border-white hover:text-white active:bg-blue-500 disabled:cursor-not-allowed"
              >
                <i class="fa-solid fa-chevron-right" />
              </button>
            </div>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            {#if signModelActive == 0 && pdfPosition != ""}
              <div class="flex w-full items-center justify-between gap-3 sm:hidden">
                <button on:click={activatePositionOverlay} class="flex h-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed lg:px-4">
                  <i class="fa-solid fa-rotate-left" />
                  &nbsp;&nbsp;Undo
                </button>
                <button
                  on:click={() => {
                    signingForm.scrollIntoView()
                    mobileViewPdfPreview = false
                  }}
                  class="flex h-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed lg:px-4"
                >
                  Done&nbsp;&nbsp;
                  <i class="fa-solid fa-check" />
                </button>
              </div>
            {/if}
          </div>
          <div bind:this={signingForm} class="h-screen w-full bg-white mobile:h-full lg:w-4/12 xls:w-3/12">
            <DocSigning {currentpage} bind:signModelActive bind:toggle bind:pdfPosition bind:signModel bind:activatePositionOverlayBtn bind:SignBgClr on:removeBlueLayer={() => deactivatePositionOverlay()} on:signPlacement={activatePositionOverlay} on:changeIndoSignedPdf={() => showPDF($SinglePublish.uri)} on:closeSignModel={clsSignModel} />
          </div>
        </div>
      {/if}
    </div>
  </div>
  <Footer />
</div>
